import * as XLSX from 'xlsx';
import { saveAs } from 'file-saver';

// Function to filter the object based on the keys in the set
export const filterObject = (object, keySet) => {
    return Object.keys(object)
        .filter(key => keySet.has(key))
        .reduce((result, key) => {
            result[key] = object[key];
            return result;
        }, {});
};

export const exportToExcel = (filteredObject, currentLocation) => {
    // Convert the JSON data to a worksheet
    const formattedData = Object.keys(filteredObject).map(key => ({
        'Label key': key,
        Value: filteredObject[key]
    }));

    // Convert the formatted data to a worksheet
    const ws = XLSX.utils.json_to_sheet(formattedData);

    // Create a workbook
    const wb = XLSX.utils.book_new();

    // Append the worksheet to the workbook
    XLSX.utils.book_append_sheet(wb, ws, 'Sheet1');

    // Export the workbook to a file
    const excelBuffer = XLSX.write(wb, { bookType: 'xlsx', type: 'array' });

    // Save the file using FileSaver
    const blob = new Blob([excelBuffer], { type: 'application/octet-stream' });
    saveAs(blob, `${currentLocation}.xlsx`);

};